/**
 * ISP-4110 (platform-wide save-500 root fix).
 *
 * The wheel builder used to hardcode `category: 1` into every segment it mapped
 * from a GET /wheel response before PUT-ing it back. Category id 1 does not
 * exist in every environment's Category table (staging starts at id 2), and the
 * backend raised on an unresolvable category id -> a raw HTTP 500 that lost the
 * user's entire wheel save (rename / delete / reorder — anything touching an
 * existing segment). Measured on app-stg 2026-07-28; pairs with BE guard PR #1540.
 *
 * The GET response already carries each segment's REAL category id at the
 * top-level `category` field (DRF `source='category.id'` / PK of a real FK, so
 * it is always a valid, existing id). This helper returns that real id instead
 * of a bogus constant. When a segment has no category, it returns undefined so
 * the key is omitted from the JSON payload and the backend keeps the stored
 * category (both are safe, measured backend behaviours — 200, persisted).
 *
 * @param {{category?: number|null}} segment - a wheel segment from the API.
 * @returns {number|null|undefined} the segment's real category id, or undefined.
 */
export function resolveSegmentCategory(segment) {
  return segment?.category;
}
